module.exports = __webpack_public_path__ + "static/media/why_bg.1e13c95f.vtt";